/**
 * JMGO Trial / Retailor launcher
 *
 * 1) Trial page: destination product page with ?jmgo_open_trial=1
 *    -> wait for Retailor's own launcher -> click it.
 * 2) New product-page: visible [data-jmgo-retailor-proxy]
 *    -> wait for the launcher generated inside the real hidden legacy
 *       main-product section -> click it.
 *
 * Retailor's own button owns popup state and cart state.
 */
(function () {
  'use strict';

  var PARAM = 'jmgo_open_trial';
  var MAX_WAIT = 25000;
  var CHECK_INTERVAL = 50;
  var opening = false;
  var RETAILOR_ORIGINS = [
    'https://connect.retailor.jp',
    'https://jmgo.try.retailor.jp'
  ];

  function addResourceHint(rel, href, crossOrigin) {
    if (!document.head || document.head.querySelector('link[rel="' + rel + '"][href="' + href + '"]')) return;
    var link = document.createElement('link');
    link.rel = rel;
    link.href = href;
    if (crossOrigin) link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  }

  function warmRetailorConnection() {
    for (var i = 0; i < RETAILOR_ORIGINS.length; i += 1) {
      addResourceHint('dns-prefetch', RETAILOR_ORIGINS[i]);
      addResourceHint('preconnect', RETAILOR_ORIGINS[i], true);
    }
  }

  function prefetchPage(url) {
    if (!url || !document.head) return;
    try {
      var target = new URL(url, window.location.href);
      target.searchParams.delete(PARAM);
      var href = target.href;
      var links = document.head.querySelectorAll('link[rel="prefetch"]');
      for (var i = 0; i < links.length; i += 1) {
        if (links[i].href === href) return;
      }
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.as = 'document';
      link.href = href;
      document.head.appendChild(link);
    } catch (error) {}
  }

  function setupTrialPagePrefetch() {
    var buttons = document.querySelectorAll('[data-jmgo-trial-launch]');
    if (!buttons.length) return;
    warmRetailorConnection();

    function warmButton(button) {
      if (!button || button.dataset.jmgoPrefetched === '1') return;
      button.dataset.jmgoPrefetched = '1';
      prefetchPage(button.href);
    }

    for (var i = 0; i < buttons.length; i += 1) {
      (function (button) {
        button.addEventListener('pointerenter', function () { warmButton(button); }, { once: true, passive: true });
        button.addEventListener('touchstart', function () { warmButton(button); }, { once: true, passive: true });
        button.addEventListener('focus', function () { warmButton(button); }, { once: true, passive: true });
      })(buttons[i]);
    }
  }

  function clickableFrom(node) {
    if (!node) return null;
    if (node.matches && node.matches('button, a, [role="button"], input[type="button"], input[type="submit"]')) {
      return node;
    }
    if (node.querySelector) {
      return node.querySelector('button, a, [role="button"], input[type="button"], input[type="submit"]') || node;
    }
    return node;
  }

  function validButton(node) {
    if (!node || !node.isConnected) return false;
    if (node.disabled || node.getAttribute('aria-disabled') === 'true') return false;
    return true;
  }

  function normalizeText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function legacyScope() {
    return document.querySelector('[id^="shopify-section-"][id*="retailor_legacy"]') ||
      document.querySelector('.js-section__product-single[data-jmgo-retailor-legacy]') ||
      null;
  }

  function findRetailorButton(preferLegacy) {
    var scopes = [];
    var legacy = legacyScope();
    if (preferLegacy && legacy) scopes.push(legacy);
    scopes.push(document);

    for (var s = 0; s < scopes.length; s += 1) {
      var scope = scopes[s];

      var exact = scope.querySelector('.LikerOfferBtn');
      if (exact) {
        exact = clickableFrom(exact);
        if (validButton(exact)) return exact;
      }

      var likely = scope.querySelectorAll(
        '[class*="LikerOffer"], [data-retailor], [class*="retailor" i], [id*="retailor" i], button, a, [role="button"]'
      );

      for (var i = 0; i < likely.length; i += 1) {
        var node = clickableFrom(likely[i]);
        if (!validButton(node)) continue;
        if (node.closest && node.closest('[data-jmgo-retailor-proxy]')) continue;

        var text = normalizeText(
          node.innerText || node.textContent || node.value || node.getAttribute('aria-label') || ''
        );
        var attrs = normalizeText([
          node.id,
          node.className,
          node.getAttribute('href'),
          node.getAttribute('data-retailor'),
          node.getAttribute('data-action'),
          node.getAttribute('data-target')
        ].join(' ')).toLowerCase();

        if (text.indexOf('お試しする') !== -1) return node;
        if (text.indexOf('お試し') !== -1 && (attrs.indexOf('retailor') !== -1 || attrs.indexOf('likeroffer') !== -1)) {
          return node;
        }
      }
    }
    return null;
  }

  function fireClick(button) {
    if (!button) return false;
    try {
      button.click();
      return true;
    } catch (error) {
      try {
        button.dispatchEvent(new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        }));
        return true;
      } catch (ignore) {
        return false;
      }
    }
  }

  function waitAndOpenRetailor(options) {
    options = options || {};
    if (opening) return;
    opening = true;
    warmRetailorConnection();

    var startedAt = Date.now();
    var observer = null;
    var timer = null;

    function cleanup() {
      if (observer) observer.disconnect();
      if (timer) window.clearInterval(timer);
      opening = false;
    }

    function tryOpen() {
      var button = findRetailorButton(!!options.preferLegacy);
      if (button) {
        cleanup();
        var clicked = fireClick(button);
        if (clicked && typeof options.onOpened === 'function') options.onOpened();
        return true;
      }

      if (Date.now() - startedAt >= MAX_WAIT) cleanup();
      return false;
    }

    if (tryOpen()) return;

    observer = new MutationObserver(tryOpen);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      characterData: true
    });

    timer = window.setInterval(tryOpen, CHECK_INTERVAL);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target && event.target.closest
      ? event.target.closest('[data-jmgo-retailor-proxy]')
      : null;
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();
    waitAndOpenRetailor({ preferLegacy: true });
  }, true);

  function shouldAutoOpen() {
    try {
      return new URL(window.location.href).searchParams.get(PARAM) === '1';
    } catch (error) {
      return false;
    }
  }

  function removeLaunchParam() {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete(PARAM);
      window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
    } catch (error) {}
  }

  if (shouldAutoOpen()) {
    waitAndOpenRetailor({ onOpened: removeLaunchParam });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupTrialPagePrefetch, { once: true });
  } else {
    setupTrialPagePrefetch();
  }
})();
